import { useState, useEffect, useRef } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import "./flow-year-enter-style.css";
import GenderMenu from "../../../dialog/default-menu/DefaultMenuDialog";
import EmotionMenu from "../../../dialog/default-menu/DefaultMenuDialog";
import IdentityMenu from "../../../dialog/default-menu/DefaultMenuDialog";
import YearMenu from "../../../dialog/default-menu/DefaultMenuDialog";
import BirthTimeMenu from "../../../dialog/default-menu/DefaultMenuDialog";
import CalenderPicker from "../../../dialog/calender/calender-picker";
import ClockPicker from "../../../dialog/clock/clock-picker";
import BirthplacePicker from "../../../dialog/birthplace-picker/birthplace-picker";
import Loading from "../../../dialog/loading/loading";
import GoogleLoginDialog from "../../../dialog/google-login/GoogleLoginDialog";
import ConfirmDialog from "../../../dialog/confirm/confirm-dialog";
import Menulist from "../../../../constant/menulist";
import useIsMobile from "../../../../hooks/useIsMobile";
import AuthService from "../../../../service/auth-service";
import UserService from "../../../../service/user-service";
import ProductService from "../../../../service/product-service";
import SiteFooter from "../../../custom/site-footer/site-footer";
import PageSeo from "../../../custom/page-seo/page-seo";
import { trackPurchase } from "../../../../utils/meta-pixel";

//—— 從已登入用戶 profile 抽出本人生辰欄位當預設值 ——
//  未登入 / 未完成註冊時回空 obj，state 就用空字串預設
const getSelfPrefill = () => {
  const p = AuthService.getUserProfile();
  if (!p || p.userValidCode !== "2") return {};
  return {
    name: p.userName || "",
    gender: p.userGender || "",
    birthDate: p.userBirthDate || "",
    birthTimeSign: p.userBirthTimeSign || "",
    timeMode: p.timeMode || "0",
    birthClockTime: p.userBirthClockTime || "",
    birthLongitude:
      p.userBirthLongitude != null ? String(p.userBirthLongitude) : "",
    birthLatitude:
      p.userBirthLatitude != null ? String(p.userBirthLatitude) : "",
    birthPlace: p.userBirthPlace || "",
  };
};

const FlowYearEnterComponent = ({
  setShowServiceMenu,
  setShowPersonalMenu,
}) => {
  //進頁時先讀 profile；若之後透過登入 dialog 才拿到 profile，會在 handleLoginSuccess 補一次
  const _prefill = getSelfPrefill();

  const [year, setYear] = useState("");
  const [name, setName] = useState(_prefill.name || "");
  const [gender, setGender] = useState(_prefill.gender || "");
  const [birthDate, setBirthDate] = useState(_prefill.birthDate || "");
  const [birthTime, setBirthTime] = useState(_prefill.birthTimeSign || "");

  //真太陽時所需資料
  const [birthClockTime, setBirthClockTime] = useState(
    _prefill.birthClockTime || "",
  );
  const [birthLongitude, setBirthLongitude] = useState(
    _prefill.birthLongitude || "",
  );
  const [birthLatitude, setBirthLatitude] = useState(
    _prefill.birthLatitude || "",
  );
  const [emotionStatus, setEmotionStatus] = useState("");
  const [identity, setIdentity] = useState("");

  //0：標準時間 / 1：真太陽時
  const [timeMode, setTimeMode] = useState(_prefill.timeMode || "0");
  const [foucsIndex, setFoucsIndex] = useState(-1);

  const [showYearMenu, setShowYearMenu] = useState(false);
  const [showGenderMenu, setShowGenderMenu] = useState(false);
  const [showEmotionMenu, setShowEmotionMenu] = useState(false);
  const [showIdentityMenu, setShowIdentityMenu] = useState(false);
  const [showBirthTimeMenu, setShowBirthTimeMenu] = useState(false);
  const [showSunTimeDes, setShowSunTimeDes] = useState(false);

  //出生地選擇（用 G-1 級聯查詢；選好後自動填 lng/lat，也可下方手動微調）
  const [showBirthplacePicker, setShowBirthplacePicker] = useState(false);
  const [birthPlaceName, setBirthPlaceName] = useState(
    _prefill.birthPlace || "",
  );

  //picker 選定 callback
  const handleBirthplaceSelect = ({ fullName, lat, lng }) => {
    setBirthPlaceName(fullName || "");
    if (typeof lng === "number") setBirthLongitude(String(lng));
    if (typeof lat === "number") setBirthLatitude(String(lat));
  };

  const isMobile = useIsMobile();
  const [navHeight, setNavHeight] = useState(0);
  const [isLoading, setIsLoading] = useState(false);

  let navigate = useNavigate();
  let location = useLocation();

  //付款流程用：待產生報告的訂單編號 + 是否正在輪詢（防重複啟動）
  //  orderID 從 /checkout 導回時透過 location.state.pendingOrderID 帶過來
  const pendingOrderIdRef = useRef(location.state?.pendingOrderID || null);
  const pollingRef = useRef(false);

  useEffect(() => {
    const nav = document.querySelector(
      isMobile ? ".mobile-dashboard nav" : ".dashboard nav",
    );
    setNavHeight(nav ? nav.offsetHeight : 0);
  }, [isMobile]);
  //完成註冊後要回到本頁
  const registerFrom = location.pathname;

  //—— Auth gating（與文章頁、命盤頁同 pattern）——
  const [showLoginDialog, setShowLoginDialog] = useState(false);
  const [showRegisterPrompt, setShowRegisterPrompt] = useState(false);

  const formRef = useRef(null);
  const scrollToForm = () =>
    formRef.current?.scrollIntoView({ behavior: "smooth" });

  //雙層判斷：!isLogin → 登入 dialog；validCode != "2" → 註冊提示；通過 → return true
  const ensureCanInteract = () => {
    const isLogin = AuthService.getLoginStatus();
    const profile = AuthService.getUserProfile();
    if (!isLogin || !profile) {
      setShowLoginDialog(true);
      return false;
    }
    if (profile.userValidCode !== "2") {
      setShowRegisterPrompt(true);
      return false;
    }
    return true;
  };

  //表單區的點擊 / focus 攔截器：未認證就阻止互動、跳 dialog
  //  捕獲階段（onClickCapture / onFocusCapture）會比子元素的 handler 先觸發
  //  → 阻擋掉就能停止下拉選單 / 輸入框等行為
  const gateFormEvent = (e) => {
    if (!ensureCanInteract()) {
      e.preventDefault();
      e.stopPropagation();
      //避免接下來的 focus 真的把 caret 落在 input 上
      if (e.target && typeof e.target.blur === "function") {
        e.target.blur();
      }
    }
  };

  const handleLoginSuccess = async ({ idToken } = {}) => {
    if (!idToken) return;
    try {
      const res = await AuthService.firebaseLogin(idToken);
      if (res.data.status) {
        AuthService.login(res.data.data);
        setShowLoginDialog(false);
        if (res.data.data.userValidCode !== "2") {
          navigate("/register", { state: { from: registerFrom } });
        } else {
          //A-1 只回 6 個欄位（name/photo/APoint…）——生辰全都不在裡面
          //  再打 B-1 拿完整 profile 存回 localStorage，才有辦法帶入 gender/birthDate/timeMode…
          try {
            const infoRes = await UserService.getPersonalInfo();
            if (infoRes.data?.status) {
              AuthService.updateUserInfo(infoRes.data.data);
            }
          } catch (err) {
            console.error("[FlowYearEnter] 拉 personal-info 失敗:", err);
          }
          const fresh = getSelfPrefill();
          setName(fresh.name || "");
          setGender(fresh.gender || "");
          setBirthDate(fresh.birthDate || "");
          setBirthTime(fresh.birthTimeSign || "");
          setTimeMode(fresh.timeMode || "0");
          setBirthClockTime(fresh.birthClockTime || "");
          setBirthLongitude(fresh.birthLongitude || "");
          setBirthLatitude(fresh.birthLatitude || "");
          setBirthPlaceName(fresh.birthPlace || "");
        }
      }
    } catch (e) {
      console.error("[FlowYearEnter] firebase-login 失敗:", e);
    }
  };

  //判斷註冊表單的資料是否填齊備
  const isFormComplete = Boolean(
    year &&
    name.trim() &&
    gender &&
    birthDate &&
    (timeMode == "0"
      ? birthTime
      : birthClockTime && birthLongitude && birthLatitude) &&
    emotionStatus &&
    identity,
  );

  const GENDER_MAP = Menulist.genderMap;
  const BIRTH_TIME_MAP = Menulist.birthTimeMap;
  const EMOTION_STATUS_MAP = Menulist.emotionStatusMap;
  const IDENTITY_STATUS_MAP = Menulist.identityStatusMap;

  //按「購買」→ 導 /checkout 選發票 → /checkout 建單、跳綠界、導回本頁
  //  用戶從綠界付款分頁切回本頁時，下方的 visibilitychange 就會開始輪詢報告
  const handlePurchase = () => {
    if (!isFormComplete) return;
    const isSun = timeMode === "1";
    const payload = {
      name: name.trim(),
      gender,
      birth: birthDate,
      year: String(year),
      emotionStatus,
      identity,
      timeMode,
      birthTimeSign: isSun ? "" : birthTime,
      birthClockTime: isSun ? birthClockTime : "",
      birthLongitude: isSun ? String(birthLongitude) : "",
      birthLatitude: isSun ? String(birthLatitude) : "",
    };
    navigate("/checkout", {
      state: {
        planID: "digital_flow",
        itemName: "流年之書解析",
        amount: 899,
        payload,
        returnPath: location.pathname,
      },
    });
  };

  //付款分頁切回來時：輪詢「綠界 callback 是否已被後端確認（paid=true）」
  //  一確認付款（不必等 AI 跑完）就直接導 /study-room，使用者立刻看到「分析中」的書
  //  AI 跑完後書房卡片會自動變成「查看內容」（study-room-page 有自己的 polling）
  useEffect(() => {
    const startPolling = async (orderId) => {
      if (pollingRef.current) return;
      pollingRef.current = true;
      setIsLoading(true);

      //輪詢付款確認的上限：通常綠界 callback 30 秒內就會打回來，給 2 分鐘 buffer
      const MAX_TRIES = 48; //× 2.5 秒 = 2 分鐘
      const INTERVAL_MS = 2500;

      for (let i = 0; i < MAX_TRIES; i++) {
        if (pendingOrderIdRef.current !== orderId) break;
        try {
          const res = await ProductService.getFlowYearReportByOrder(orderId);
          const d = res.data?.data;
          //paid=true 就跳轉（不必等 ready；分析中 / 已完成 / 失敗都各自在書房有對應 UI）
          if (d?.paid) {
            //Meta Pixel Purchase 事件（帶 orderID 跟後端 CAPI 去重）
            trackPurchase({
              productID: "digital_flow",
              productName: "流年之書",
              amount: 899,
              orderID: orderId,
            });
            pendingOrderIdRef.current = null;
            pollingRef.current = false;
            setIsLoading(false);
            navigate("/study-room");
            return;
          }
        } catch (e) {
          console.log(e);
        }
        await new Promise((r) => setTimeout(r, INTERVAL_MS));
      }

      //輪詢超時：付款 callback 沒收到，使用者可能根本沒付款 / 綠界異常
      //  保險導去 /study-room，使用者要嘛看到剛產生的書、要嘛沒看到（代表付款沒成功）
      pendingOrderIdRef.current = null;
      pollingRef.current = false;
      setIsLoading(false);
      navigate("/study-room");
    };

    const onVisible = () => {
      if (
        document.visibilityState === "visible" &&
        pendingOrderIdRef.current &&
        !pollingRef.current
      ) {
        startPolling(pendingOrderIdRef.current);
      }
    };
    document.addEventListener("visibilitychange", onVisible);
    return () => document.removeEventListener("visibilitychange", onVisible);
  }, [navigate]);

  const handleToReport = () => {
    if (!isFormComplete) return;
    handlePurchase();
  };

  const currentYear = new Date().getFullYear();

  const YEAR_MAP = {
    [currentYear]: `${currentYear}`,
    [currentYear + 1]: `${currentYear + 1}`,
  };

  return (
    <div className="flow-year-enter-page">
      <PageSeo
        title="流年之書｜運勢深度解析"
        description="完整解讀你的流年運勢、六大面向、十二月節奏，看清今年的機會與課題。由資深命理師團隊操刀，給你一本可實際走過這一年的命理導覽。"
        path="/flow-enter"
      />
      {/* 產生流年之書中（呼叫 Gemini，可能數十秒）*/}
      {isLoading && <Loading />}


      {/* 未登入訪客點到表單時跳出；關掉 → 留在當前頁 */}
      {showLoginDialog && (
        <GoogleLoginDialog
          open={showLoginDialog}
          onClose={() => {
            setShowLoginDialog(false);
          }}
          onSuccess={handleLoginSuccess}
        />
      )}

      {/* 已登入但未完成註冊；關掉 → 留在當前頁 */}
      <ConfirmDialog
        open={showRegisterPrompt}
        onClose={() => {
          setShowRegisterPrompt(false);
        }}
        onSuccess={() => {
          setShowRegisterPrompt(false);
          navigate("/register", { state: { from: registerFrom } });
        }}
        title="尚未完成註冊"
        message="填寫流年之書資料前需完成註冊，<br>是否前往註冊頁完成？"
        confirmTxt="前往註冊"
      />

      {!isMobile && (
        <main
          className="web-main"
          style={{ paddingTop: navHeight }}
          onMouseEnter={() => {
            setShowServiceMenu(false);
            setShowPersonalMenu(false);
          }}
          onClick={() => {
            setShowYearMenu(false);
            setShowGenderMenu(false);
            setShowEmotionMenu(false);
            setShowIdentityMenu(false);
            setShowBirthTimeMenu(false);
            setShowSunTimeDes(false);
          }}
        >
          <img
            className="banner"
            src={`/images/bg-flow-web-banner.png`}
            loading="lazy"
            alt="流年運勢圖片"
            onClick={scrollToForm}
          />

          <div className="first-block">
            <p className="slogan">
              很多時候，不是不夠努力<br></br>
              而是你不知道「什麼時間點，該做對的事」
            </p>

            <div className="feeling-question">
              <img src={`/images/ic-question-mark.png`}></img>
              <p className="question">你是不是也有這種感覺：</p>
              <p className="feeling">明明很努力，卻得不到成果 🥲</p>
              <p className="feeling">有機會來了，但找不到好時機 🤔</p>
              <p className="feeling">想做決定，卻怕走錯方向 😵‍💫</p>
            </div>
          </div>

          <div className="second-block">
            <p>
              我們把複雜命盤，翻譯成你真的看得懂、用得上的行動指南<br></br>
              不只是「算出來」，而是告訴你——什麼時候該做什麼，才能更順
            </p>
          </div>

          <div className="third-block">
            <p className="title">掌握今年的起伏與轉機</p>
            <p className="sub-title">流年報告就是你的「年度導航系統」</p>
            <div className="outer">
              <div className="inner">
                <p className="inner-title">我們會告訴你</p>
                <p className="inner-answer">
                  <span className="highlight">
                    你今年真正要面對的核心課題！
                  </span>
                </p>
                <p className="inner-answer">
                  <span className="highlight">
                    哪個月行動最好？又該避開哪個月？
                  </span>
                </p>
                <p className="inner-answer">
                  <span className="highlight">
                    面對不同情境，你可以怎麼做？
                  </span>
                </p>
              </div>
            </div>
          </div>

          <div className="fourth-block" ref={formRef}>
            <img
              src={`/images/ic-flow-year.png`}
              loading="lazy"
              alt="流年運勢圖片"
            />
            <p className="slogan">
              現在就輸入出生時間<br></br>看懂流年運勢關鍵
            </p>

            {/*資料輸入卡*/}
            <div
              className="flow-input-card"
              onMouseDownCapture={gateFormEvent}
              onClickCapture={gateFormEvent}
              onFocusCapture={gateFormEvent}
            >
              {/*你目前的身份*/}
              <div
                className={`item-info menu ${foucsIndex == 0 ? "foucs" : "non-focus"}`}
                onClick={(e) => {
                  e.stopPropagation();
                  setShowGenderMenu(false);
                  setShowEmotionMenu(false);
                  setShowIdentityMenu(false);
                  setShowYearMenu(!showYearMenu);
                }}
              >
                <p>想算的流年為</p>
                <input
                  className="input-block"
                  placeholder="請選擇年份"
                  readOnly
                  value={YEAR_MAP[year]}
                  onFocus={() => {
                    setFoucsIndex(0);
                  }}
                ></input>
                <img src="../images/ic-brown-down.png"></img>
                {showYearMenu && (
                  <div className="float-menu">
                    <YearMenu
                      dataMap={YEAR_MAP}
                      onSuccess={(year) => {
                        setYear(year);
                      }}
                      onClose={() => setShowYearMenu(false)}
                    ></YearMenu>
                  </div>
                )}
              </div>

              {/*你的姓名*/}
              <div
                className={`item-info ${foucsIndex == 1 ? "foucs" : "non-focus"}`}
              >
                <p>你的姓名</p>
                <input
                  className="input-block"
                  placeholder="請輸入姓名"
                  maxLength={10}
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  onFocus={() => {
                    setFoucsIndex(1);
                  }}
                ></input>
              </div>

              {/*你的性別選單*/}
              <div
                className={`item-info menu ${foucsIndex == 2 ? "foucs" : "non-focus"}`}
                onClick={(e) => {
                  e.stopPropagation();
                  setShowGenderMenu(!showGenderMenu);
                }}
              >
                <p>性別</p>
                <input
                  className="input-block"
                  placeholder="請選擇生理性別"
                  readOnly
                  value={GENDER_MAP[gender]}
                  onFocus={() => {
                    setFoucsIndex(2);
                  }}
                ></input>
                <img src="../images/ic-brown-down.png"></img>
                {showGenderMenu && (
                  <div className="float-menu">
                    <GenderMenu
                      dataMap={GENDER_MAP}
                      onSuccess={(gender) => {
                        setGender(gender);
                      }}
                      onClose={() => setShowGenderMenu(false)}
                    ></GenderMenu>
                  </div>
                )}
              </div>

              {/*你的出生日期日曆*/}
              <div
                className={`item-info  ${foucsIndex == 3 ? "foucs" : "non-focus"}`}
              >
                <p>出生日期</p>
                <div className="calender">
                  <CalenderPicker
                    birthDate={birthDate}
                    setBirthDate={setBirthDate}
                    onFocus={() => {
                      setFoucsIndex(3);
                    }}
                  />
                </div>
                <img src="../images/ic-brown-down.png"></img>
              </div>

              {/*標準時間／太陽時選擇*/}
              <div className="select-radio">
                <div className="option">
                  <input
                    type="radio"
                    name="method"
                    id="standard"
                    value="standard"
                    checked={timeMode === "0"}
                    onChange={() => setTimeMode("0")}
                  />
                  <label htmlFor="standard">標準時間</label>
                </div>

                <div className="option suntime">
                  <input
                    type="radio"
                    name="method"
                    id="sun"
                    value="sun"
                    checked={timeMode === "1"}
                    onChange={() => setTimeMode("1")}
                  />
                  <label htmlFor="sun">真太陽時</label>

                  <img
                    onClick={(e) => {
                      setShowGenderMenu(false);
                      setShowBirthTimeMenu(false);
                      setShowSunTimeDes(true);
                      e.stopPropagation();
                    }}
                    src="../images/ic-description.png"
                  ></img>

                  <div className="suntime-tag">
                    {showSunTimeDes && (
                      <div
                        className="suntime-des"
                        onClick={(e) => {
                          e.stopPropagation();
                        }}
                      >
                        <p className="title">什麼是真太陽時？</p>
                        <p className="des">
                          真太陽時（True Solar Time）是以天文學算式計算太陽
                          相對地平線的位置的時間，反映某地實際日照狀況。當
                          太陽位於當地子午線上時，即為「真正的中午」。它不同
                          於人為劃分的標準時間，因為地球自轉與公轉的影響，真
                          太陽時會因地點與日期而有所變化，真太陽時則能根據
                          個人的出生經緯度，精確地還原當地的實際時間。
                        </p>
                      </div>
                    )}
                  </div>
                </div>
              </div>

              {/*出生時辰-標準時間選單*/}
              {timeMode == "0" && (
                <div
                  className={`item-info menu ${foucsIndex == 4 ? "foucs" : "non-focus"}`}
                  onClick={(e) => {
                    setShowSunTimeDes(false);
                    setShowGenderMenu(false);
                    setShowBirthTimeMenu(!showBirthTimeMenu);
                    e.stopPropagation();
                  }}
                >
                  <p>出生時辰</p>
                  <input
                    className="input-block"
                    placeholder="早子時 00:00-00:59"
                    value={BIRTH_TIME_MAP[birthTime]}
                    readOnly
                    onFocus={() => {
                      setFoucsIndex(4);
                    }}
                  ></input>
                  <img src="../images/ic-brown-down.png"></img>
                  {showBirthTimeMenu && (
                    <div className="float-menu">
                      <BirthTimeMenu
                        dataMap={BIRTH_TIME_MAP}
                        onSuccess={(birthTime) => {
                          setBirthTime(birthTime);
                        }}
                        onClose={() => setShowBirthTimeMenu(false)}
                      ></BirthTimeMenu>
                    </div>
                  )}
                </div>
              )}

              {/*出生時辰-真太陽時選單*/}
              {timeMode == "1" && (
                <div>
                  <div
                    className={`item-info menu ${foucsIndex == 5 ? "foucs" : "non-focus"}`}
                    onClick={(e) => {
                      setShowSunTimeDes(false);
                      setShowGenderMenu(false);
                      e.stopPropagation();
                    }}
                  >
                    <p>出生時辰</p>

                    <ClockPicker
                      clockTime={birthClockTime}
                      setClockTime={setBirthClockTime}
                      onFocus={() => {
                        setFoucsIndex(5);
                      }}
                    />

                    <img src="../images/ic-brown-down.png"></img>
                  </div>

                  {/*快速選擇出生地：自己一格，跟出生時辰同層；選好自動填入下方經緯度*/}
                  <div
                    className={`item-info menu ${foucsIndex == 8 ? "foucs" : "non-focus"}`}
                    onClick={(e) => {
                      setShowSunTimeDes(false);
                      setShowGenderMenu(false);
                      setFoucsIndex(8);
                      setShowBirthplacePicker(true);
                      e.stopPropagation();
                    }}
                  >
                    <p>選擇出生地</p>
                    <span
                      className="input-block"
                      style={{
                        marginLeft: "2.5rem",
                        fontSize: "1.1rem",
                        color: birthPlaceName
                          ? undefined
                          : "rgba(198, 198, 198)",
                      }}
                    >
                      {birthPlaceName || "請選擇"}
                    </span>
                    <img src="../images/ic-brown-down.png"></img>
                  </div>

                  <div
                    style={{
                      fontSize: "0.8rem",
                      marginBottom: "0.5rem",
                      color: "rgb(108, 49, 57)",
                    }}
                  >
                    * 選擇出生地後，將自動帶入該地經緯度
                  </div>

                  <div
                    className={`born-place ${timeMode == "1" ? "showBlock" : "hideBlock"}`}
                  >
                    <div
                      className={`item-info place ${foucsIndex == 6 ? "foucs" : "non-focus"}`}
                      onClick={(e) => {
                        setShowSunTimeDes(false);
                        setShowGenderMenu(false);
                        e.stopPropagation();
                      }}
                    >
                      <p>出生地-經度</p>

                      <input
                        type="number"
                        className="input-block"
                        min="-180"
                        max="180"
                        step="any" //允許小數
                        inputMode="decimal" //手機顯示小數鍵盤
                        placeholder="請輸入經度"
                        value={birthLongitude}
                        onChange={(e) => {
                          setBirthLongitude(e.target.value);
                        }}
                        onFocus={() => {
                          setFoucsIndex(6);
                        }}
                      ></input>
                    </div>

                    <div className="space"></div>

                    <div
                      className={`item-info place ${foucsIndex == 7 ? "foucs" : "non-focus"}`}
                      onClick={(e) => {
                        setShowSunTimeDes(false);
                        setShowGenderMenu(false);
                        e.stopPropagation();
                      }}
                    >
                      <p>出生地-緯度</p>

                      <input
                        className="input-block"
                        type="number"
                        step="any"
                        inputMode="decimal"
                        placeholder="請輸入緯度"
                        min="-90"
                        max="90"
                        value={birthLatitude}
                        onChange={(e) => {
                          setBirthLatitude(e.target.value);
                        }}
                        onFocus={() => {
                          setFoucsIndex(7);
                        }}
                      ></input>
                    </div>
                  </div>
                </div>
              )}

              {/*你目前的感情狀態*/}
              <div
                className={`item-info menu ${foucsIndex == 8 ? "foucs" : "non-focus"}`}
                onClick={(e) => {
                  e.stopPropagation();
                  setShowGenderMenu(false);
                  setShowEmotionMenu(!showEmotionMenu);
                }}
              >
                <p>感情狀態</p>
                <input
                  className="input-block"
                  placeholder="未婚無伴/未婚有伴/已婚"
                  readOnly
                  value={EMOTION_STATUS_MAP[emotionStatus]}
                  onFocus={() => {
                    setFoucsIndex(8);
                  }}
                ></input>
                <img src="../images/ic-brown-down.png"></img>
                {showEmotionMenu && (
                  <div className="float-menu">
                    <EmotionMenu
                      dataMap={EMOTION_STATUS_MAP}
                      onSuccess={(status) => {
                        setEmotionStatus(status);
                      }}
                      onClose={() => setShowEmotionMenu(false)}
                    ></EmotionMenu>
                  </div>
                )}
              </div>

              {/*你目前的身份*/}
              <div
                className={`item-info menu ${foucsIndex == 9 ? "foucs" : "non-focus"}`}
                onClick={(e) => {
                  e.stopPropagation();
                  setShowGenderMenu(false);
                  setShowEmotionMenu(false);
                  setShowIdentityMenu(!showIdentityMenu);
                }}
              >
                <p>身份</p>
                <input
                  className="input-block"
                  placeholder="請選擇最符合的身份"
                  readOnly
                  value={IDENTITY_STATUS_MAP[identity]}
                  onFocus={() => {
                    setFoucsIndex(9);
                  }}
                ></input>
                <img src="../images/ic-brown-down.png"></img>
                {showIdentityMenu && (
                  <div className="float-menu">
                    <IdentityMenu
                      dataMap={IDENTITY_STATUS_MAP}
                      onSuccess={(identity) => {
                        setIdentity(identity);
                      }}
                      onClose={() => setShowIdentityMenu(false)}
                    ></IdentityMenu>
                  </div>
                )}
              </div>

              <button
                className={`${isFormComplete ? "active" : "disabled"}`}
                disabled={!isFormComplete}
                onClick={() => {
                  handleToReport();
                }}
              >
                獲取流年之書 NT$899
              </button>
            </div>

            <div className="bonus">
              <img
                src={`/images/ic-bonus-star.png`}
                loading="lazy"
                alt="額外加贈"
              ></img>
              <span className="label">額外加贈</span>
              <span className="content">流年諮詢１次</span>
            </div>

            <p className="expert-hint">
              對流年之書的內容還有問題想問嗎？<br></br>
              透過專業諮詢去提問，大師將會親自回覆您！
            </p>
          </div>

          <div className="fifth-block">
            <span>
              陪你走過這一年每一個重要時刻<br></br>
              在迷惘時給方向，在關鍵時給提醒
            </span>
          </div>

          <div className="six-block">
            <img src={`/images/ic-more-stars.png`} loading="lazy" />
            <p className="tell">這份流年之書會告訴你</p>

            <div className="outline">
              <div className="item-title">
                <span className="number">1</span>
                <span>｜</span>
                <span className="title">今年的課題是什麼</span>
              </div>
              <div className="item-sub">
                <span>為什麼今年會發生很多事？</span>
                <span>提早看懂，很多彎路其實可以不用走</span>
              </div>
            </div>
            <div className="outline">
              <div className="item-title">
                <span className="number">2</span>
                <span>｜</span>
                <span className="title">年度題字與解析</span>
              </div>
              <div className="item-sub">
                <span>用一個字，濃縮你整年的運勢核心</span>
                <span>但會讓你一看就懂今年的主軸</span>
              </div>
            </div>
            <div className="outline">
              <div className="item-title">
                <span className="number">3</span>
                <span>｜</span>
                <span className="title">六大面向完整解析 🔥</span>
              </div>
              <span className="analyze">
                （事業 / 財運 / 愛情 / 人際 / 家庭 / 健康）
              </span>
              <div className="item-sub">
                <span>
                  不只是分析好壞，而是告訴你：
                  <br></br>◆ 哪裡可以衝
                  <br></br>◆ 哪裡要穩一點
                  <br></br>◆ 怎麼做更順
                </span>
              </div>
            </div>
            <div className="outline">
              <div className="item-title">
                <span className="number">4</span>
                <span>｜</span>
                <span className="title">流月提示情境＋行動指引 🔥</span>
              </div>

              <div className="item-sub">
                <span>
                  不是只有運勢好不好，而是直接告訴你：
                  <br></br>◆ 這個月可能會遇到什麼情況
                  <br></br>◆ 你該怎麼應對
                  <br></br>◆ 建議你採取什麼行動
                </span>
              </div>
            </div>
            <div className="outline">
              <div className="item-title">
                <span className="number">5</span>
                <span>｜</span>
                <span className="title">結語總整理</span>
              </div>

              <div className="item-sub">
                <span>
                  幫你收斂整年重點<br></br>讓你帶著清楚方向一路往前走！
                </span>
              </div>
            </div>
          </div>

          <div className="seven-block">
            <p>讓每個時間點，都有對應的行動策略</p>
            <span onClick={scrollToForm}>現在就解鎖你的專屬流年之書</span>
          </div>
          <SiteFooter />
        </main>
      )}

      {isMobile && (
        <main
          className="mobile-main"
          style={{ paddingTop: navHeight }}
          onMouseEnter={() => {
            setShowServiceMenu(false);
            setShowPersonalMenu(false);
          }}
          onClick={() => {
            setShowYearMenu(false);
            setShowGenderMenu(false);
            setShowEmotionMenu(false);
            setShowIdentityMenu(false);
            setShowBirthTimeMenu(false);
            setShowSunTimeDes(false);
          }}
        >
          <img
            className="banner"
            src={`/images/bg-flow-mobile-banner.png`}
            loading="lazy"
            alt="流年運勢圖片"
            onClick={scrollToForm}
          />
          <div className="first-block">
            <p className="slogan">
              很多時候，不是你不夠努力
              <br />
              而是你不知道「什麼時間點，該做對的事」
            </p>
            <div className="feeling-question">
              <img src={`/images/ic-question-mark.png`} alt="問號" />
              <p className="question">你是不是也有這種感覺：</p>
              <p className="feeling">明明很努力，卻得不到成果 🥲</p>
              <p className="feeling">有機會來了，但找不到好時機 🤔</p>
              <p className="feeling">想做決定，卻怕走錯方向 😵‍💫</p>
            </div>
          </div>

          <div className="second-block">
            <p>
              我們把複雜命盤，翻譯成你真的看得懂、
              <br />
              用得上的行動指南不只是「算出來」，
              <br />
              而是告訴你——什麼時候該做什麼，才能更順
            </p>
          </div>

          <div className="third-block">
            <p className="title">掌握今年的起伏與轉機</p>
            <p className="sub-title">流年報告就是你的「年度導航系統」</p>
            <div className="outer">
              <div className="inner">
                <p className="inner-title">我們會告訴你</p>
                <p className="inner-answer">
                  <span className="highlight">你今年真正要面對的核心課題</span>
                </p>
                <p className="inner-answer">
                  <span className="highlight">
                    哪個月行動最好？又該避開哪個月？
                  </span>
                </p>
                <p className="inner-answer">
                  <span className="highlight">面對不同情境，你可以怎麼做</span>
                </p>
              </div>
            </div>
          </div>

          <div className="fourth-block" ref={formRef}>
            <img
              src={`/images/ic-flow-year.png`}
              loading="lazy"
              alt="流年運勢圖片"
            />
            <p className="slogan">
              現在就輸入出生時間
              <br />
              看懂流年運勢關鍵
            </p>

            <div
              className="flow-input-card"
              onMouseDownCapture={gateFormEvent}
              onClickCapture={gateFormEvent}
              onFocusCapture={gateFormEvent}
            >
              <div
                className={`item-info menu ${foucsIndex === 0 ? "foucs" : "non-focus"}`}
                onClick={(e) => {
                  e.stopPropagation();
                  setShowGenderMenu(false);
                  setShowEmotionMenu(false);
                  setShowIdentityMenu(false);
                  setShowYearMenu(!showYearMenu);
                }}
              >
                <p>想算的流年為</p>
                <input
                  className="input-block"
                  placeholder="請選擇年份"
                  readOnly
                  value={YEAR_MAP[year] || ""}
                  onFocus={() => setFoucsIndex(0)}
                />
                <img src="../images/ic-brown-down.png" alt="" />
                {showYearMenu && (
                  <div className="float-menu">
                    <YearMenu
                      dataMap={YEAR_MAP}
                      onSuccess={(y) => setYear(y)}
                      onClose={() => setShowYearMenu(false)}
                    />
                  </div>
                )}
              </div>

              <div
                className={`item-info ${foucsIndex === 1 ? "foucs" : "non-focus"}`}
              >
                <p>你的姓名</p>
                <input
                  className="input-block"
                  placeholder="請輸入姓名"
                  maxLength={10}
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  onFocus={() => setFoucsIndex(1)}
                />
              </div>

              <div
                className={`item-info menu ${foucsIndex === 2 ? "foucs" : "non-focus"}`}
                onClick={(e) => {
                  e.stopPropagation();
                  setShowGenderMenu(!showGenderMenu);
                }}
              >
                <p>性別</p>
                <input
                  className="input-block"
                  placeholder="請選擇生理性別"
                  readOnly
                  value={GENDER_MAP[gender] || ""}
                  onFocus={() => setFoucsIndex(2)}
                />
                <img src="../images/ic-brown-down.png" alt="" />
                {showGenderMenu && (
                  <div className="float-menu">
                    <GenderMenu
                      dataMap={GENDER_MAP}
                      onSuccess={(g) => setGender(g)}
                      onClose={() => setShowGenderMenu(false)}
                    />
                  </div>
                )}
              </div>

              <div
                className={`item-info ${foucsIndex === 3 ? "foucs" : "non-focus"}`}
              >
                <p>出生日期</p>
                <div className="calender">
                  <CalenderPicker
                    birthDate={birthDate}
                    setBirthDate={setBirthDate}
                    onFocus={() => setFoucsIndex(3)}
                  />
                </div>
                <img src="../images/ic-brown-down.png" alt="" />
              </div>

              <div className="select-radio">
                <div className="option">
                  <input
                    type="radio"
                    name="mobile-method"
                    id="mobile-standard"
                    value="standard"
                    checked={timeMode === "0"}
                    onChange={() => setTimeMode("0")}
                  />
                  <label htmlFor="mobile-standard">標準時間</label>
                </div>
                <div className="option suntime">
                  <input
                    type="radio"
                    name="mobile-method"
                    id="mobile-sun"
                    value="sun"
                    checked={timeMode === "1"}
                    onChange={() => setTimeMode("1")}
                  />
                  <label htmlFor="mobile-sun">真太陽時</label>
                  <img
                    onClick={(e) => {
                      setShowGenderMenu(false);
                      setShowBirthTimeMenu(false);
                      setShowSunTimeDes(true);
                      e.stopPropagation();
                    }}
                    src="../images/ic-description.png"
                    alt=""
                  />
                  <div className="suntime-tag">
                    {showSunTimeDes && (
                      <div
                        className="suntime-des"
                        onClick={(e) => e.stopPropagation()}
                      >
                        <p className="title">什麼是真太陽時？</p>
                        <p className="des">
                          真太陽時（True Solar Time）是以天文學算式計算太陽
                          相對地平線的位置的時間，反映某地實際日照狀況。當
                          太陽位於當地子午線上時，即為「真正的中午」。它不同
                          於人為劃分的標準時間，因為地球自轉與公轉的影響，真
                          太陽時會因地點與日期而有所變化，真太陽時則能根據
                          個人的出生經緯度，精確地還原當地的實際時間。
                        </p>
                      </div>
                    )}
                  </div>
                </div>
              </div>

              {timeMode === "0" && (
                <div
                  className={`item-info menu ${foucsIndex === 4 ? "foucs" : "non-focus"}`}
                  onClick={(e) => {
                    setShowSunTimeDes(false);
                    setShowGenderMenu(false);
                    setShowBirthTimeMenu(!showBirthTimeMenu);
                    e.stopPropagation();
                  }}
                >
                  <p>出生時辰</p>
                  <input
                    className="input-block"
                    placeholder="早子時 00:00-00:59"
                    value={BIRTH_TIME_MAP[birthTime] || ""}
                    readOnly
                    onFocus={() => setFoucsIndex(4)}
                  />
                  <img src="../images/ic-brown-down.png" alt="" />
                  {showBirthTimeMenu && (
                    <div className="float-menu">
                      <BirthTimeMenu
                        dataMap={BIRTH_TIME_MAP}
                        onSuccess={(bt) => setBirthTime(bt)}
                        onClose={() => setShowBirthTimeMenu(false)}
                      />
                    </div>
                  )}
                </div>
              )}

              {timeMode === "1" && (
                <div>
                  <div
                    className={`item-info menu ${foucsIndex === 5 ? "foucs" : "non-focus"}`}
                    onClick={(e) => {
                      setShowSunTimeDes(false);
                      setShowGenderMenu(false);
                      e.stopPropagation();
                    }}
                  >
                    <p>出生時辰</p>
                    <ClockPicker
                      clockTime={birthClockTime}
                      setClockTime={setBirthClockTime}
                      onFocus={() => setFoucsIndex(5)}
                    />
                    <img src="../images/ic-brown-down.png" alt="" />
                  </div>

                  {/*快速選擇出生地：自己一格，跟出生時辰同層；選好自動填入下方經緯度*/}
                  <div
                    className={`item-info menu ${foucsIndex === 8 ? "foucs" : "non-focus"}`}
                    onClick={(e) => {
                      setShowSunTimeDes(false);
                      setShowGenderMenu(false);
                      setFoucsIndex(8);
                      setShowBirthplacePicker(true);
                      e.stopPropagation();
                    }}
                  >
                    <p>選擇出生地</p>
                    <span
                      className="input-block"
                      style={{
                        marginLeft: "1rem",
                        fontSize: "0.95rem",
                        color: birthPlaceName
                          ? undefined
                          : "rgba(198, 198, 198)",
                      }}
                    >
                      {birthPlaceName || "請選擇"}
                    </span>
                    <img src="../images/ic-brown-down.png" alt="" />
                  </div>

                  <div
                    style={{
                      fontSize: "0.8rem",
                      marginBottom: "1rem",
                      color: "rgb(108, 49, 57)",
                    }}
                  >
                    * 選擇出生地後，將自動帶入該地經緯度
                  </div>

                  <div
                    className={`born-place ${timeMode === "1" ? "showBlock" : "hideBlock"}`}
                  >
                    <div
                      className={`item-info place ${foucsIndex === 6 ? "foucs" : "non-focus"}`}
                      onClick={(e) => {
                        setShowSunTimeDes(false);
                        setShowGenderMenu(false);
                        e.stopPropagation();
                      }}
                    >
                      <p>出生地-經度</p>
                      <input
                        type="number"
                        className="input-block"
                        min="-180"
                        max="180"
                        step="any"
                        inputMode="decimal"
                        placeholder="請輸入經度"
                        value={birthLongitude}
                        onChange={(e) => setBirthLongitude(e.target.value)}
                        onFocus={() => setFoucsIndex(6)}
                      />
                    </div>
                    <div className="space" />
                    <div
                      className={`item-info place ${foucsIndex === 7 ? "foucs" : "non-focus"}`}
                      onClick={(e) => {
                        setShowSunTimeDes(false);
                        setShowGenderMenu(false);
                        e.stopPropagation();
                      }}
                    >
                      <p>出生地-緯度</p>
                      <input
                        className="input-block"
                        type="number"
                        step="any"
                        inputMode="decimal"
                        placeholder="請輸入緯度"
                        min="-90"
                        max="90"
                        value={birthLatitude}
                        onChange={(e) => setBirthLatitude(e.target.value)}
                        onFocus={() => setFoucsIndex(7)}
                      />
                    </div>
                  </div>
                </div>
              )}

              <div
                className={`item-info menu ${foucsIndex === 8 ? "foucs" : "non-focus"}`}
                onClick={(e) => {
                  e.stopPropagation();
                  setShowGenderMenu(false);
                  setShowEmotionMenu(!showEmotionMenu);
                }}
              >
                <p>感情狀態</p>
                <input
                  className="input-block"
                  placeholder="未婚無伴/未婚有伴/已婚"
                  readOnly
                  value={EMOTION_STATUS_MAP[emotionStatus] || ""}
                  onFocus={() => setFoucsIndex(8)}
                />
                <img src="../images/ic-brown-down.png" alt="" />
                {showEmotionMenu && (
                  <div className="float-menu">
                    <EmotionMenu
                      dataMap={EMOTION_STATUS_MAP}
                      onSuccess={(s) => setEmotionStatus(s)}
                      onClose={() => setShowEmotionMenu(false)}
                    />
                  </div>
                )}
              </div>

              <div
                className={`item-info menu ${foucsIndex === 9 ? "foucs" : "non-focus"}`}
                onClick={(e) => {
                  e.stopPropagation();
                  setShowGenderMenu(false);
                  setShowEmotionMenu(false);
                  setShowIdentityMenu(!showIdentityMenu);
                }}
              >
                <p>身份</p>
                <input
                  className="input-block"
                  placeholder="請選擇最符合的身份"
                  readOnly
                  value={IDENTITY_STATUS_MAP[identity] || ""}
                  onFocus={() => setFoucsIndex(9)}
                />
                <img src="../images/ic-brown-down.png" alt="" />
                {showIdentityMenu && (
                  <div className="float-menu">
                    <IdentityMenu
                      dataMap={IDENTITY_STATUS_MAP}
                      onSuccess={(id) => setIdentity(id)}
                      onClose={() => setShowIdentityMenu(false)}
                    />
                  </div>
                )}
              </div>

              <button
                className={isFormComplete ? "active" : "disabled"}
                disabled={!isFormComplete}
                onClick={handleToReport}
              >
                獲取流年之書 NT$899
              </button>
            </div>

            <div className="bonus">
              <img
                src={`/images/ic-bonus-star.png`}
                loading="lazy"
                alt="額外加贈"
              />
              <span className="label">額外加贈</span>
            </div>

            <span className="bonus-content">流年諮詢１次</span>

            <p className="expert-hint">
              對流年之書的內容還有問題想問嗎？
              <br />
              透過專業諮詢去提問，大師將會親自回覆您！
            </p>
          </div>

          <div className="fifth-block">
            <span>
              陪你走過這一年每一個重要時刻
              <br />
              在迷惘時給方向，在關鍵時給提醒
            </span>
          </div>

          <div className="six-block">
            <img src={`/images/ic-more-stars.png`} loading="lazy" alt="" />
            <p className="tell">這份流年之書會告訴你</p>

            <div className="outline">
              <div className="item-title">
                <span className="number">1</span>
                <span>｜</span>
                <span className="title">今年的課題是什麼</span>
              </div>
              <div className="item-sub">
                <span>為什麼今年會發生這些事？</span>
                <span>提早看懂，很多彎路其實可以不用走</span>
              </div>
            </div>

            <div className="outline">
              <div className="item-title">
                <span className="number">2</span>
                <span>｜</span>
                <span className="title">年度題字與解析</span>
              </div>
              <div className="item-sub">
                <span>用一個字，濃縮你整年的運勢核心</span>
                <span>簡單，但會讓你一看就懂今年的主軸</span>
              </div>
            </div>

            <div className="outline">
              <div className="item-title">
                <span className="number">3</span>
                <span>｜</span>
                <span className="title">六大面向完整解析 🔥</span>
              </div>
              <span className="analyze">
                （事業 / 財運 / 愛情 / 人際 / 家庭 / 健康）
              </span>
              <div className="item-sub">
                <span>
                  不只是分析好壞，而是告訴你：
                  <br />◆ 哪裡可以衝
                  <br />◆ 哪裡要穩一點
                  <br />◆ 怎麼做更順
                </span>
              </div>
            </div>

            <div className="outline">
              <div className="item-title">
                <span className="number">4</span>
                <span>｜</span>
                <span className="title">流月提示情境＋行動指引 🔥</span>
              </div>
              <div className="item-sub">
                <span>
                  不是只有運勢好不好，而是直接告訴你：
                  <br />◆ 這個月可能會遇到什麼情況
                  <br />◆ 你該怎麼應對
                  <br />◆ 建議你採取什麼行動
                </span>
              </div>
            </div>

            <div className="outline">
              <div className="item-title">
                <span className="number">5</span>
                <span>｜</span>
                <span className="title">結語總整理</span>
              </div>
              <div className="item-sub">
                <span>
                  幫你收斂整年重點
                  <br />
                  讓你帶著清楚方向一路往前走！
                </span>
              </div>
            </div>
          </div>

          <div className="seven-block">
            <p>讓每個時間點，都有對應的行動策略</p>
            <span onClick={scrollToForm}>現在就解鎖你的專屬流年之書</span>
          </div>
          <SiteFooter />
        </main>
      )}

      {/* 出生地級聯選擇（真太陽時模式下用） */}
      <BirthplacePicker
        open={showBirthplacePicker}
        onClose={() => setShowBirthplacePicker(false)}
        onSelect={handleBirthplaceSelect}
      />
    </div>
  );
};

export default FlowYearEnterComponent;
